import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import formatNumber from '../../../../utils/formatNumber';
import { colors } from '../../../../constants/colors';
import styles from '../deal.module.css';

// Ð£ÑÐ»Ð¾Ð²Ð¸Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ Ð±Ð°Ð½ÐºÐ° Ð¿ÑÑÐ¼Ð¾ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÑÐ´ÐµÐ»ÐºÐ¸. Ð Ð°Ð½ÑÑÐµ, ÑÑÐ¾Ð±Ñ Ð¸Ñ Ð¿Ð¾ÑÐ¼Ð¾ÑÑÐµÑÑ,
// Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°Ð»ÑÑ ÑÑÑÐµÐ»ÐºÐ°Ð¼Ð¸ Ðº Ð²ÑÐ±Ð¾ÑÑ Ð±Ð°Ð½ÐºÐ° â Ð° Ð¿Ð¾Ð²ÑÐ¾ÑÐ½ÑÐ¹ Ð²ÑÐ±Ð¾Ñ Ð¾ÑÐ¼ÐµÐ½ÑÐµÑ
// Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð´ÑÑÐ³Ð¸Ñ Ð±Ð°Ð½ÐºÐ°Ñ. Ð¡Ð¼Ð¾ÑÑÐµÑÑ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾.
// ÐÐ°ÑÑÐ¾ÑÑÐ¸Ðµ ÑÑÐ»Ð¾Ð²Ð¸Ñ Ð±Ð°Ð½ÐºÐ° Ð»ÐµÐ¶Ð°Ñ Ð² ÐµÐ³Ð¾ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ (other_conditions). Ð ÑÐ°Ð¼Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐµ
// Ñ ÑÐ°ÑÑÐ¸ Ð±Ð°Ð½ÐºÐ¾Ð² Ð¾ÑÑÐ°ÑÑÑÑ Ð·Ð°Ð¿ÑÐ¾ÑÐµÐ½Ð½Ð¾Ðµ: Ñ Ð¤Ð¾ÑÑÐµ percent = ÑÑÐ°Ð²ÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ñ (10 %),
// Ð¿Ð»Ð°ÑÑÐ¶ ÑÐ°ÑÑÑÑÐ½ÑÐ¹ â Ð² ÑÐ´ÐµÐ»ÐºÐµ 193990 Ð±Ð»Ð¾Ðº Ð¿Ð¾ÐºÐ°Ð·Ð°Ð» 10 % Ð¸ 169 750 â¸ Ð²Ð¼ÐµÑÑÐ¾ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð½ÑÑ
// 23 % Ð¸ 308 205 â¸. ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð±ÐµÑÑÐ¼ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, ÐºÐ¾ÑÐ¾ÑÐ¾Ðµ Ð²ÑÐ±ÑÐ°Ð» Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ.
export const chosenOffer = (appeal) => {
  const offers = appeal?.other_conditions || [];
  if (offers.length === 0) return null;
  const picked = offers.find(
    (offer) => appeal?.offerType != null && String(offer?.offerType) === String(appeal.offerType)
  );
  return picked || (offers.length === 1 ? offers[0] : null);
};

export const chosenBankRows = (appeal) => {
  if (!appeal) return [];
  const money = (value) => (value ? `${formatNumber(value)} â¸` : null);
  const offers = appeal?.other_conditions || [];
  const offer = chosenOffer(appeal);

  if (offer) {
    return [
      ['ÐÐ°Ð½Ðº:', appeal?.bank?.name],
      ['Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°:', money(offer?.amount)],
      ['ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ:', money(offer?.initialFee || appeal?.initialFee)],
      ['Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:', offer?.term ? `${offer.term} Ð¼ÐµÑ.` : null],
      ['Ð¡ÑÐ°Ð²ÐºÐ°:', offer?.rate ? `${offer.rate}%` : null],
      ['ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÑÐ¶:', money(offer?.payment || offer?.monthlyInstalmentAmountKZ)],
      ['ÐÐÐ¡ÐÐ:', money(offer?.cascoAmount || appeal?.cascoAmount || appeal?.kasko_amount)],
    ].filter(([, value]) => value);
  }

  // ÐÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾, Ð° ÐºÐ°ÐºÐ¾Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð¾ â Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð¾: ÑÑÐ°Ð²ÐºÑ Ð¸ Ð¿Ð»Ð°ÑÑÐ¶ Ð½Ðµ
  // Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð²Ð¾Ð²ÑÐµ, Ð½ÐµÐ²ÐµÑÐ½Ð°Ñ ÑÐ¸ÑÑÐ° ÑÑÐ¶Ðµ Ð¿ÑÑÑÐ¾Ð³Ð¾ Ð¼ÐµÑÑÐ°. ÐÑÑ Ð²Ð¸Ð´Ð½Ð¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÐ°Ð½ÐºÐ¸Â».
  if (offers.length > 1) {
    return [
      ['ÐÐ°Ð½Ðº:', appeal?.bank?.name],
      ['ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ:', money(appeal?.initialFee)],
    ].filter(([, value]) => value);
  }

  return [
    ['ÐÐ°Ð½Ðº:', appeal?.bank?.name],
    ['Ð¡ÑÐ¼Ð¼Ð° Ð·Ð°Ð¹Ð¼Ð°:', money(appeal?.loan_amount)],
    ['ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ:', money(appeal?.initialFee)],
    ['Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ:', appeal?.period ? `${appeal.period} Ð¼ÐµÑ.` : null],
    ['Ð¡ÑÐ°Ð²ÐºÐ°:', appeal?.percent ? `${appeal.percent}%` : null],
    ['ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÑÐ¶:', money(appeal?.monthlyPayment)],
    ['ÐÐÐ¡ÐÐ:', money(appeal?.cascoAmount || appeal?.kasko_amount)],
  ].filter(([, value]) => value);
};

const ChosenBankConditions = ({ appeal, dealId }) => {
  const { pathname } = useLocation();
  const rows = chosenBankRows(appeal);
  if (rows.length === 0) return null;

  // ÐÐ»Ð¾Ðº Ð²Ð¸Ð´ÐµÐ½ Ð½Ð° Ð²ÑÐµÑ Ð²ÐºÐ»Ð°Ð´ÐºÐ°Ñ ÑÐ´ÐµÐ»ÐºÐ¸. ÐÐ° ÑÐ°Ð¼Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÐ°Ð½ÐºÐ¸Â» ÑÑÑÐ»ÐºÐ° Ð²ÐµÐ»Ð° Ð±Ñ
  // Ð½Ð° ÑÑ Ð¶Ðµ ÑÑÑÐ°Ð½Ð¸ÑÑ â ÐºÐ»Ð¸Ðº Ð²ÑÐ³Ð»ÑÐ´ÐµÐ» ÐºÐ°Ðº Â«Ð½Ðµ Ð½Ð°Ð¶Ð¸Ð¼Ð°ÐµÑÑÑÂ».
  const banksPath = `/deals/deal/${dealId}/credit`;
  const onBanksTab = pathname === banksPath;

  return (
    <>
      {rows.map(([name, value]) => (
        <React.Fragment key={name}>
          <p className={styles.stepsRow__name}>{name}</p>
          <p className={styles.stepsRow__value}>{value}</p>
        </React.Fragment>
      ))}
      {dealId && !onBanksTab ? (
        <>
          <p className={styles.stepsRow__name}>ÐÑÐ²ÐµÑÑ Ð²ÑÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²:</p>
          <p className={styles.stepsRow__value}>
            <Link to={banksPath} onClick={() => window.scrollTo(0, 0)} style={{ color: colors?.cameo, textDecoration: 'underline' }}>
              Ð²ÐºÐ»Ð°Ð´ÐºÐ° Â«ÐÐ°Ð½ÐºÐ¸Â»
            </Link>
          </p>
        </>
      ) : null}
    </>
  );
};

export default ChosenBankConditions;
